// 9fbef606107a605d69c0edbcd8029e5d
import constants from '../RewardsCard.constants';

/**
 * @const - fetchModuleX
 * @param - payload - accepts contentIds object to fetch module data against.
 *
 * @description - fetchModuleX action to fetch the content.
 */
export const fetchModuleX = (payload) => {
  return {
    payload,
    type: constants.FETCH_MODULEX_CONTENT,
  };
};

/**
 * @const - setModuleX
 *
 * @description - setting the modulesX data.
 */
export const setModuleX = (payload) => {
  return {
    payload,
    type: constants.SET_MODULEX_CONTENT,
  };
};

/**
 * @const - submitInstantCardApplication
 * @param - payload- payload accepts form data for PLCC Card application.
 *
 * @description - sending the PLCC request.
 */
export const submitInstantCardApplication = (payload) => {
  return {
    payload,
    type: constants.SEND_INSTANT_CARD_APPLICATION,
  };
};

/**
 * @const - obtainInstantCardApplication
 * @param - payload- contains the data of PLCC application request.
 *
 * @description - fetching the instant status of applied PLCC card.
 */
export const obtainInstantCardApplication = (payload) => {
  return {
    payload,
    type: constants.RESPONSE_INSTANT_CARD_APPLICATION,
  };
};

/**
 * @const - resetPLCCResponse
 * @param - payload- replace application status with null
 *
 */
export const resetPLCCResponse = (payload) => {
  return {
    payload,
    type: constants.RESET_PLCC_APPLICATION_RESPONSE,
  };
};

export const resetPLCCInstantCardApplication = (payload) => {
  return {
    payload,
    type: constants.RESET_PLCC_INSTANT_CARD_APPLICATION,
  };
};

export const setPlccEligible = (payload) => {
  return {
    payload,
    type: constants.SET_PLCC_ELIGIBLE,
  };
};

export const setPlccPrescreenCode = (payload) => {
  return {
    payload,
    type: constants.SET_PLCC_PRESCREEN_CODE,
  };
};

export const setPrescreenFromBrowse = (payload) => {
  return {
    payload,
    type: constants.SET_PRESCREEN_FROM_BROWSE,
  };
};

export const setActiveErrorField = (payload) => {
  return {
    payload,
    type: constants.SET_ACTIVE_ERROR_FIELD,
  };
};

export const setIsRegisteredUser = (payload) => {
  return {
    payload,
    type: constants.SET_IS_REGISTERED_USER,
  };
};

export const setIsNewUser = (payload) => {
  return {
    payload,
    type: constants.SET_IS_NEW_USER,
  };
};

export const setIsPlccDone = (payload) => {
  return {
    payload,
    type: constants.SET_IS_PLCC_DONE,
  };
};

export const setCreateAccountTempPass = (payload) => {
  return {
    payload,
    type: constants.SET_CREATE_ACCOUNT_PASS,
  };
};

export const setCreateAdsAccountFailed = (payload) => {
  return {
    payload,
    type: constants.SET_CREATE_ADS_ACCOUNT_FAILED,
  };
};

export const resetApplyCardReducer = () => {
  return {
    type: constants.RESET_APPLY_CARD_REDUCER,
  };
};

export const fromPaymentMobile = (payload) => {
  return {
    payload,
    type: constants.FROM_PAYMENT_MOBILE,
  };
};
